// extracted by mini-css-extract-plugin
export default {"ConsentForm":"ConsentForm_ConsentForm__4U6ZL","title":"ConsentForm_title__THalf","request":"ConsentForm_request__B25KT"};